import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const OrganRoute = LazyLoad(
  lazy(() => import('./organ').then((module) => ({ default: module.Organ }))),
);
